import n from "./_has.mjs";
var r = Object.prototype.toString, o = /* @__PURE__ */ function() {
  return r.call(arguments) === "[object Arguments]" ? function(t) {
    return r.call(t) === "[object Arguments]";
  } : function(t) {
    return n("callee", t);
  };
}();
export {
  o as default
};
